<template>
    <registration-base>
        <template #center v-if="isNotFound">
            <period-not-found></period-not-found>
        </template>

        <template #information v-else-if="period">
            <info-card :period="period"></info-card>
        </template>

        <template #registration v-if="! isNotFound && period">
            <register-or-join-card
                @join="join"
                @signup="signup"
                :period="period"
            ></register-or-join-card>
        </template>
    </registration-base>
</template>

<script>
import PeriodNotFound from './components/PeriodNotFound'
import RegistrationBase from './RegistrationBase.vue'
import InfoCard from './components/InfoCard.vue'
import RegisterOrJoinCard from './components/RegisterOrJoinCard.vue'

export default {
    components: {
        PeriodNotFound,
        RegistrationBase,
        InfoCard,
        RegisterOrJoinCard,
    },

    data() {
        return {
            isNotFound: false,
            period: null,
        }
    },

    methods: {
        async join() {
            await this.$api.post(`tryoutPeriod/${this.period.id}/enroll`, {}, { loader: 'join' })
            this.$tracking.event.program.register(this.period.title)

            const response = await this.$api.get('enrollment', { loader: 'join' })
            this.$store.set('enrollment/enrollments', response.data.enrollments)
            this.$store.dispatch('enrollment/selectByPeriodId', this.period.id)
            localStorage.setItem('lastSelectedPeriodId', this.period.id)
            this.$tracking.event.program.register(this.period.title)
            this.$router.replace({ name: 'payment' })
        },
        async signup(data) {
            this.$store.set('home/period', this.period)

            await this.$store.dispatch('auth/signup', { data })

            localStorage.setItem('lastSelectedPeriodId', this.period.id)
            this.$tracking.event.program.register(this.period.title)
            this.$router.replace({ name: 'payment' })
        },
    },

    async created() {
        try {
            const response = await this.$api.get(`tryoutPeriod/${this.$route.params.slug}`, { loader: 'registration' })

            this.period = response.data
        } catch (error) {
            if (error.response && error.response.status === 404) {
                this.isNotFound = true
            } else {
                throw error
            }
        }
    }
}
</script>
